










































































































































































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import { Agence } from "@/store/modules/Agence/interface";
import { ApiResponse, FormType, Location_, IMapDataDefinition, PickStr, UserRole } from "@/types/types";
import { SurveyActionsTypes } from "@/store/modules/Survey/types";
import Kml, { KmlContent, KmlFolders } from "@/plugins/kml";
import Utils from "@/utils/utils";
import Map from "@/components/Map/Map.vue";
import { Poste } from "@/store/modules/Poste/interface";
import { PosteActionsTypes } from "@/store/modules/Poste/types";
import { Response_ } from "@/plugins/axios/response";

const typePoste: PickStr<any> = {
  CA: "automatique",
  CS: "section",
  CD: "directionnel"
};

export default Vue.extend({
  name: "SurveyCreateModal",
  components: { Modal, Map },
  props: {
    should_display: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function,
      default: () => undefined
    },
    survey: {
      type: Object
    },
    onAction: {
      type: Function,
      default: () => undefined
    }
  },
  created(): void {
    this.postes_ = [];
  },
  data(): any {
    return {
      form: this.$props.survey
        ? this.$props.survey
        : { id_budget: "", name_survey: "", type: "", agence: "", start_date: "", end_date: "", emails: [] },
      type: this.$props.survey ? FormType.UPDATE : FormType.CREATE,
      start_date_menu: false,
      end_date_menu: false,
      loading: false,
      email: "",
      postes: [],
      displayMap: false,
      headers: [
        { text: "Nom du poste", align: "center", value: "name_poste" },
        { text: "Typologie", align: "center", value: "typology" },
        { text: "actions", value: "actions", sortable: false, width: "10%" }
      ]
    };
  },
  mounted() {
    if (this.type === FormType.UPDATE) {
      delete this.form.user;
      delete this.form.active;
    }
  },
  methods: {
    displayTitle() {
      return this.type === FormType.UPDATE ? "Modifier une enquête" : "Créer une Enquête";
    },
    displayButtonName() {
      return this.type === FormType.UPDATE ? "Modifier" : "Créer";
    },
    onInputChange(value: string, type: string) {
      this.form[type] = value;
    },
    async transformKmlIntoPoste(file_uploaded: File) {
      if (!file_uploaded) {
        this.displayMap = false;
        this.postes_ = [];
      } else {
        const kml = new Kml(file_uploaded);
        await kml.xmlToDom();
        const kml_json = kml.domToJson();
        const results = this.transformJsonInPoste(kml_json);
        this.postes_ = kml_json.length > 0 ? [...results["CA"], ...results["CS"], ...results["CD"]] : [];
        this.displayMap = true;
      }
    },
    transformJsonInPoste(kml_json: Array<KmlFolders>): any {
      const postes: PickStr<any> = { CA: [], CS: [], CD: [] };
      kml_json.forEach((kml_folder: KmlFolders) => {
        const name = kml_folder.name;
        if (kml_folder.obj) {
          const kml_postes = kml_folder.obj;
          kml_postes.forEach((kml_content: KmlContent) => {
            if (!postes[name].find((poste: any) => kml_content.name === poste.name_poste)) {
              const occurence = kml_postes.filter((poste) => poste.name === kml_content.name);
              // Si le nombre d'occurence est de deux cela veut normalement dire qu'il y a un un polygon ainsi qu'un point
              let point_location = null;
              let polygon_location = null;
              if (occurence.length == 2) {
                point_location = (occurence.find((r) => r.type === "Point") as KmlContent).locations;
                polygon_location =
                  (occurence.find((r) => r.type === "Polygon" || r.type === "LineString") as KmlContent).locations ||
                  null;
              } else {
                point_location = (occurence[0] as KmlContent).locations;
              }
              postes[name].push({
                name_poste: kml_content.name,
                typology: typePoste[name],
                material: null,
                comment: "",
                real_location: null,
                theoretical_location: Utils.arrayToLocation(point_location),
                polygon_location:
                  polygon_location !== null ? Utils.arrayToLocation(polygon_location) : polygon_location,
                survey: null,
                angle_location: null
              });
            }
          });
        }
      });
      return postes;
    },
    async createSurvey(): Promise<Response_> {
      return store.dispatch(SurveyActionsTypes.CREATE_SURVEY, this.form);
    },
    async createPoste(survey_id: string): Promise<Response_> {
      this.postes_.forEach((poste: any) => {
        poste.survey = survey_id;
        poste.agence = this.form.agence;
      });
      const data: any = {
        postes: this.postes_,
        survey_id: survey_id
      };
      return await store.dispatch(PosteActionsTypes.CREATE_POSTES, data);
    },
    async updateSurvey(_id: string): Promise<Response_> {
      return store.dispatch(SurveyActionsTypes.UPDATE_SURVEY, {
        survey_data: this.form,
        _id: this.survey._id
      });
    },
    async validate(): Promise<void> {
      this.loading = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const request_result =
          this.type === FormType.CREATE ? await this.createSurvey() : await this.updateSurvey(this.$props?.survey?._id);
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          if (this.postes_.length > 0) {
            const request_result_poste = await this.createPoste(
              (request_result as Response_).body._id || this.$props.survey._id
            );
            if (
              (request_result_poste as Response_).status === ApiResponse.CREATED ||
              (request_result_poste as Response_).status === ApiResponse.SUCCESS
            ) {
              this.successAction((request_result_poste as Response_).message);
              this.loading = false;
              this.onClose();
              return;
            } else this.errorAction((request_result_poste as Response_).message);
          } else {
            this.successAction((request_result as Response_).message);
            this.loading = false;
            this.onClose();
            return;
          }
        } else this.errorAction((request_result as Response_).message);
        this.loading = false;
      }
    },
    format_poste(): Array<IMapDataDefinition> {
      return this.postes_.map((poste: any) => {
        return {
          ...poste,
          name: poste.name_poste,
          location: poste.real_location
        };
      });
    },
    errorAction(message: string): void {
      this.onAction({
        type: "Error",
        title: "Erreur",
        content: message
      });
    },
    successAction(message: string): void {
      this.onAction({
        type: "SUCCESS",
        title: "Enquête Créer",
        content: message
      });
    },
    addEmail() {
      if (!this.form.emails) this.form.emails = [];
      if (
        this.email &&
        this.email !== "" &&
        this.form.emails.find((email: string) => email === this.email) === undefined &&
        this.email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]{2,}\.[a-z]{2,4}$/)
      ) {
        this.form.emails.push(this.email);
        this.email = "";
      }
    },
    delEmail(email: string) {
      this.form.emails = this.form.emails.filter((e: string) => e !== email);
    }
  },
  computed: {
    id_budgetRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Le champ Id Budget est obligatoire.`];
    },
    name_surveyRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Le champ nom est obligatoire.`];
    },
    typeRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ type est obligatoire.`,
        (value: string): boolean | string =>
          value.toLowerCase() === "pycam" ||
          value.toLowerCase() === "lapi" ||
          value.toLowerCase() == "lapi-observer" ||
          value.toLowerCase() == "autre" ||
          `La valeur doit être présente dans le menu déroulant.`
      ];
    },
    agenceRules(): Array<(value: string) => boolean | string> {
      return [
        (value: string): boolean | string => value.length > 0 || `Le champ agence est obligatoire.`,
        (value: string): boolean | string =>
          this.agences.find((agence: any) => agence._id === value) === undefined
            ? `La valeur renseignée n'est pas valide`
            : true
      ];
    },
    fileRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => this.type !== null || `Un fichier kml est obligatoire.`];
    },
    endDateRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Une date de fin est obligatoire.`];
    },
    startDateRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Une date de commencement est obligatoire.`];
    },
    agences(): Array<Agence> {
      const logged_user = store.getters.LOGGED_USER;
      return store.getters.ROLE_BY_ID[logged_user?.role as string].name.toUpperCase() === UserRole.ADMINISTRATOR
        ? store.getters.AGENCE_ALL_ID.map((agence) => store.getters.AGENCE_BY_ID[agence])
        : [store.getters.AGENCE_BY_ID[logged_user?.agence as string]];
    },
    center(): Array<number> {
      const position = this.postes
        .map((poste: Poste) => poste.theoretical_location)
        .reduce((a: Location_, b: Location_) => {
          a.longitude = Number(a.longitude) + Number(b.longitude);
          a.latitude = Number(a.latitude) + Number(b.latitude);
          return a;
        });
      return [position.longitude / this.postes.length, position.latitude / this.postes.length];
    }
  }
});
